import { Skeleton, TableCell, TableRow } from '@mui/material';
import { totalRowCellStyles } from './Panel/styles';

type Props = {
  unitLabel: string;
  loading: boolean;
  totalLogged: number;
  totalFormValue: number;
  totalCalculatedValue?: number;
  isError?: boolean;
};

export const TotalSumRow = ({
  unitLabel,
  loading,
  totalLogged,
  totalFormValue,
  totalCalculatedValue,
  isError = false,
}: Props) => {
  return (
    <TableRow>
      <TableCell
        sx={{
          ...totalRowCellStyles,
          color: 'text.primary',
          border: 1,
          borderRight: 0,
          borderColor: 'divider',
          borderLeft: '1px solid #E0E0E0 !important',
          borderBottom: '1px solid #E0E0E0 !important',
        }}
      >
        Total {unitLabel?.toLowerCase() || ''} logged
      </TableCell>
      <TableCell
        sx={{
          ...totalRowCellStyles,
          color: 'text.primary',
          borderBottom: '1px solid #E0E0E0 !important',
          borderLeft: '1px solid #E0E0E0 !important',
        }}
      >
        {loading ? <Skeleton variant="text" /> : totalLogged}
      </TableCell>
      {totalCalculatedValue !== undefined && (
        <TableCell
          sx={{
            ...totalRowCellStyles,
            borderBottom: '1px solid #E0E0E0 !important',
            pl: 4,
            color: isError ? 'error.main' : 'text.primary',
          }}
        >
          {loading ? <Skeleton variant="text" /> : totalCalculatedValue}{' '}
        </TableCell>
      )}
      <TableCell
        sx={{
          ...totalRowCellStyles,
          borderBottom: '1px solid #E0E0E0 !important',
          pl: 4,
          color: 'text.primary',
        }}
      >
        {loading ? <Skeleton variant="text" /> : totalFormValue}{' '}
      </TableCell>
      <TableCell
        sx={{
          ...totalRowCellStyles,
          borderBottom: '1px solid #E0E0E0 !important',
          borderRight: '1px solid #E0E0E0 !important',
        }}
      />
    </TableRow>
  );
};
